export default __webpack_public_path__ + "static/media/satfleet-screenshots.9c84d112.jpg";